import { Component, Injector, OnInit } from '@angular/core';
import { BaseAdminPanelComponent } from '../../base-admin-panel/base-admin-panel.component';
import { CompaniesService, CompanyModel, CompanyStatisticsViewModel, CompanyStatus } from "../../../../services/companies.service";
import { CreateCompanyComponent } from '../create-company/create-company.component';
import { EditCompanyComponent } from '../edit-company/edit-company.component';
import { Observable, of } from 'rxjs';


@Component({
    selector: '[app-companies]',
    templateUrl: './companies.component.html',
    styleUrls: ['./companies.component.css'],
    standalone: false
})
export class CompaniesComponent extends BaseAdminPanelComponent implements OnInit {

  selectedCompanyIds: number[] = [];
  public term: string;
  private service: CompaniesService;

  constructor(protected injector: Injector) {
    super(injector);
    this.entityName = "Company";
    this.service = injector.get(CompaniesService);
  }
  protected Refresh() {
    // this.service.getCompanies().subscribe((res) => this.objects = res.map((company: CompanyModel) => {
    //   let res = new CompanyItemViewModel();
    //   res.init(company);
    //   return res;
    // }));

    this.service.getCompaniesStatistics().subscribe((res) => this.objects = res);
  }

  public editCommand(company: CompanyItemViewModel) {
    this.prepareModal(EditCompanyComponent);
    this.componentRef.instance.open(company);
  }

  public openCreateModal() {
    this.prepareModal(CreateCompanyComponent);
    this.componentRef.instance.open(new CompanyItemViewModel());
  }

  protected doDeleteObject(id: number): Observable<any> {
    return this.service.delete(id);
  }

  public deleteObject(id: number) {
    if (!confirm(this.translate.instant("Delete Company")))
      return;

    this.service.delete(id).subscribe(() => {
      this.Refresh();
    });
  }

  public getStatus(company: CompanyStatisticsViewModel) {
    return company.Status == CompanyStatus.Active ? this.translate.instant("Active Company") : this.translate.instant("Blocked Company");
  }

  public companyFilterChange(companyIds: number[] | null | undefined) {
    this.selectedCompanyIds = companyIds ?? [];
    this.objects.forEach((obj) => obj.IsChecked = false);
  }

  public getFilteredObjects() {
    if (this.selectedCompanyIds.length === 0)
      return this.objects;

    const companies = this.objects as CompanyStatisticsViewModel[];
    const lookup = this.createLookupMap(companies);
    const filteredCompanies = new Map<number, CompanyStatisticsViewModel>();

    for (const companyId of this.selectedCompanyIds) {
      for (const company of this.getCompanyTree(companies, companyId, lookup)) {
        filteredCompanies.set(company.Id, company);
      }
    }

    return Array.from(filteredCompanies.values());
  }

  private getCompanyTree(
    companies: CompanyStatisticsViewModel[],
    companyId: number,
    lookup: Map<number, CompanyStatisticsViewModel[]> = this.createLookupMap(companies)
  ): CompanyStatisticsViewModel[] {
    const result: CompanyStatisticsViewModel[] = [];

    // Add the selected company itself
    const rootCompany = companies.find(c => c.Id === companyId);
    if (rootCompany) {
      result.push(rootCompany);
    }
    // Fetch all child companies
    this.traverseTree(companyId, lookup, result);
    return result;
  }

  private createLookupMap(companies: CompanyStatisticsViewModel[]): Map<number, CompanyStatisticsViewModel[]> {
    const lookup = new Map<number, CompanyStatisticsViewModel[]>();

    // Initialize lookup with empty arrays for each company ID
    companies.forEach(company => lookup.set(company.Id, []));

    // Populate lookup with children
    companies.forEach(company => {
      if (company.ParentCompanyId !== null) {
        lookup.get(company.ParentCompanyId)?.push(company);
      }
    });

    return lookup;
  }

  private traverseTree(
    id: number,
    lookup: Map<number, CompanyStatisticsViewModel[]>,
    result: CompanyStatisticsViewModel[]
  ): void {
    const children = lookup.get(+id) || [];
    for (const child of children) {
      result.push(child);
      this.traverseTree(child.Id, lookup, result);
    }
  }
}


export class CompanyItemViewModel extends CompanyModel {

  public init(data: CompanyModel) {
    this.Id = data.Id;
    this.ParentCompanyId = data.ParentCompanyId;
    this.Name = data.Name;
    this.Phone = data.Phone;
    this.Email = data.Email;
    this.ContactName = data.ContactName;
    this.PostAddress = data.PostAddress;
    this.CompanyStatus = data.CompanyStatus;
  }
}
